import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from 'rxjs/operators';


import { isNull } from "../utils";
import { QrCodeCadastroDto } from "../model/qr-code-cadastro-dto";
import { Lista } from "../model/lista";

@Injectable()
export class ListaFormCadastroService {
    private api: string;

    constructor(private httpClient: HttpClient) { 
        this.api = '/api/ListaFormCadastro';
    }

    public criar(listaId: number) {
        return this.httpClient.post<number>(`${this.api}/`, listaId);
    }

    public BuscarQrCode(listaId: number) {
        return this.httpClient.get<QrCodeCadastroDto>(`${this.api}/qrcode/lista/${listaId}`);
    }

    public ValidarToken(token: string) {
        return this.httpClient.get<Lista>(`${this.api}/token/${token}`);
    }

    public incluirItemLista(token, json) {
		return this.httpClient.post<any>(
			`${this.api}/inserir-item/${token}`,
			json
		);
	}

    public atualizarStatus(QrCodeCadastroDto) {
		return this.httpClient.put<any>(
			`${this.api}`,
			QrCodeCadastroDto
		);
	}
}
